import {
    STORAGE_KEY
} from '../common/constants';

let storedData = {
    settings: {
        lang: process.env.VUE_APP_I18N_LOCALE || "de"
    },

    user: {
        data: null
    },
};

const notStoredData = {
    userLogin: {
        uid: null,
        isNewUser: false
    },
    selectedCompany: null,
    showMenu: false
};

if (localStorage.getItem(STORAGE_KEY)) {
    storedData = JSON.parse(localStorage.getItem(STORAGE_KEY));
}

export default Object.assign(storedData, notStoredData);